const HospitalsList = () =>
	import(
		/* webpackChunkName: "hospitalslist"*/ "@/views/HospitalsList/index.vue"
	);
const HospitalsCreate = () =>
	import(
		/* webpackChunkName: "hospitalscreate"*/ "@/views/Hospital/Create/index.vue"
	);
const HospitalsView = () =>
	import(/* webpackChunkName: "hospitalsview"*/ "@/views/Hospital/index.vue");
const HospitalsEdit = () =>
	import(
		/* webpackChunkName: "hospitalsedit"*/ "@/views/Hospital/Edit/index.vue"
	);
const HospitalsMetrics = () =>
	import(
		/* webpackChunkName: "hospitalsmetrics"*/ "@/views/Hospital/Metrics/index.vue"
	);
const HospitalsUsersInvite = () =>
	import(
		/* webpackChunkName: "hospitalsusersinvite"*/ "@/views/Hospital/Users/Invite.vue"
	);
const HospitalGroupCreate = () =>
	import(
		/* webpackChunkName: "hospitalgroupcreate"*/ "@/views/Hospital/Group/Create.vue"
	);
const HospitalGroupEdit = () =>
	import(
		/* webpackChunkName: "hospitalgroupedit"*/ "@/views/Hospital/Group/Edit.vue"
	);

export default [
	{
		path: "hospitals",
		name: "HospitalsList",
		component: HospitalsList,
		meta: {
			title: "DailyAdmin - Super hospital list"
		}
	},
	{
		path: "hospitals/create",
		name: "HospitalsCreate",
		component: HospitalsCreate,
		meta: {
			title: "DailyAdmin - Hospital create"
		}
	},
	{
		path: "hospitals/view/:id",
		name: "HospitalsView",
		component: HospitalsView,
		meta: {
			title: "DailyAdmin - Hospital view"
		}
	},
	{
		path: "hospitals/edit/:id",
		name: "HospitalsEdit",
		component: HospitalsEdit,
		meta: {
			title: "DailyAdmin - Hospital edit"
		}
	},
	{
		path: "hospitals/metrics/:id",
		name: "HospitalsMetrics",
		component: HospitalsMetrics,
		meta: {
			title: "DailyAdmin - Hospital metrics"
		}
	},
	{
		path: "hospitals/invite/:id",
		name: "HospitalsUsersInvite",
		component: HospitalsUsersInvite,
		meta: {
			title: "DailyAdmin - Hospital user invite"
		}
	},
	{
		path: "hospitals/group-create/:id",
		name: "HospitalGroupCreate",
		component: HospitalGroupCreate,
		meta: {
			title: "DailyAdmin - Hospital group create"
		}
	},
	{
		path: "hospitals/group-edit/:id/:groupid",
		name: "HospitalGroupEdit",
		component: HospitalGroupEdit,
		meta: {
			title: "DailyAdmin - Hospital group edit"
		}
	}
];
